"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.light = void 0;
exports.light = [
    //-- 'ART' 
    {
        material: 'ART',
        title: 'SAPRA LD202/1 ',
        article: '2200348',
        wats: '64W',
        color: 'белый',
        diameter: '60×30×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '3520Lm',
        img: '/img/lamps/lights/2200348.jpg',
        price: '53.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD202/1 ',
        article: '2200349',
        wats: '64W',
        color: 'чёрный',
        diameter: '60×30×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '3520Lm',
        img: '/img/lamps/lights/2200349.jpg',
        price: '53.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD202/2 ',
        article: '2200350',
        wats: '108W',
        color: 'белый',
        diameter: '',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '5940Lm',
        img: '/img/lamps/lights/2200350.jpg',
        price: '68.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD202/2 ',
        article: '2200351',
        wats: '108W',
        color: 'чёрный',
        diameter: '',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '5940Lm',
        img: '/img/lamps/lights/2200351.jpg',
        price: '68.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD202/3 ',
        article: '2200352',
        wats: '196W',
        color: 'белый',
        diameter: '80×40×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '10780Lm',
        img: '/img/lamps/lights/2200352.jpg',
        price: '115.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD202/3 ',
        article: '2200353',
        wats: '196W',
        color: 'чёрный',
        diameter: '80×40×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '10780Lm',
        img: '/img/lamps/lights/2200353.jpg',
        price: '115.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/1 ',
        article: '2200354',
        wats: '46W',
        color: 'белый',
        diameter: 'Ø40×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '2530Lm',
        img: '/img/lamps/lights/2200354.jpg',
        price: '44.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/1 ',
        article: '2200355',
        wats: '46W',
        color: 'чёрный',
        diameter: 'Ø40×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '2530Lm',
        img: '/img/lamps/lights/2200355.jpg',
        price: '44.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/1 ',
        article: '2200356',
        wats: '70W',
        color: 'белый',
        diameter: 'Ø60×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '3850Lm',
        img: '/img/lamps/lights/2200356.jpg',
        price: '63.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/1',
        article: '2200357',
        wats: '70W',
        color: 'чёрный',
        diameter: 'Ø60×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '3850Lm',
        img: '/img/lamps/lights/2200357.jpg',
        price: '63.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/2 ',
        article: '2200358',
        wats: '116W',
        color: 'белый',
        diameter: 'Ø60×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '6380Lm',
        img: '/img/lamps/lights/2200358.jpg',
        price: '79.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/2',
        article: '2200359',
        wats: '116W',
        color: 'чёрный',
        diameter: 'Ø60×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '6380Lm',
        img: '/img/lamps/lights/2200359.jpg',
        price: '79.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/3',
        article: '2200360',
        wats: '162W',
        color: 'белый',
        diameter: 'Ø80×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '8910Lm',
        img: '/img/lamps/lights/2200360.jpg',
        price: '119.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD204/3',
        article: '2200361',
        wats: '162W',
        color: 'чёрный',
        diameter: 'Ø80×max.107 см',
        colorLightK: '3000-6000K',
        patron: 'есть',
        lightStream: '8910Lm',
        img: '/img/lamps/lights/2200361.jpg',
        price: '119.00'
    },
    {
        material: 'ART',
        title: 'SAPRA LD304/2',
        article: ' 2300599',
        wats: '120W',
        color: 'хром',
        diameter: 'Ø60×max.80 см',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 6600 Lm',
        img: '/img/lamps/lights/2300599.jpg',
        price: '170.00'
    },
    //-- STARLIGHT 
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL361',
        article: '2200128',
        wats: '36W',
        color: 'белая',
        diameter: 'Ø455×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: '2900Lm',
        img: '/img/lamps/lights/2200128.jpg',
        price: '29.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL361',
        article: '2200129',
        wats: '36W',
        color: 'белая',
        diameter: 'Ø455×70 мм',
        colorLightK: '4000K',
        patron: 'нет',
        lightStream: '2900Lm',
        img: '/img/lamps/lights/2200129.jpg',
        price: '24.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL721',
        article: '2200130',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø570×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: '5000Lm',
        img: '/img/lamps/lights/2200130.jpg',
        price: '33.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL182',
        article: '2200131',
        wats: '18W',
        color: 'белый',
        diameter: 'Ø340×70 мм',
        colorLightK: '4000K',
        patron: 'есть',
        lightStream: '1400Lm',
        img: '/img/lamps/lights/2200131.jpg',
        price: '6.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL242',
        article: '2200132',
        wats: '24W',
        color: 'белый',
        diameter: 'Ø400×70 мм',
        colorLightK: '4000K',
        patron: 'нет',
        lightStream: '1900Lm',
        img: '/img/lamps/lights/2200132.jpg',
        price: '14.99'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL362',
        article: '2200133',
        wats: '36W',
        color: 'белый',
        diameter: 'Ø400×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 2900Lm',
        img: '/img/lamps/lights/2200133.jpg',
        price: '25.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL362',
        article: '2200134',
        wats: '36W',
        color: 'белый',
        diameter: 'Ø400×70 мм',
        colorLightK: '4000K',
        patron: 'нет',
        lightStream: '2900Lm',
        img: '/img/lamps/lights/2200134.jpg',
        price: '22.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL722',
        article: '2200135',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200135.jpg',
        price: '33.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL363',
        article: '2200136',
        wats: '36W',
        color: 'белый',
        diameter: 'Ø390×60 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 2900Lm',
        img: '/img/lamps/lights/2200136.jpg',
        price: '26.50'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL363',
        article: '2200137',
        wats: '36W',
        color: 'белый',
        diameter: 'Ø390×60 мм',
        colorLightK: '4000K',
        patron: 'нет',
        lightStream: '2900Lm',
        img: '/img/lamps/lights/2200137.jpg',
        price: '24.30'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL723',
        article: '2200138',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×60 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200138.jpg',
        price: '33.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL724',
        article: '2200139',
        wats: '72W',
        color: 'белый',
        diameter: '440×440×60 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200139.jpg',
        price: '48.20'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL725',
        article: '2200140',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×80 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200140.jpg',
        price: '38.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL726',
        article: '2200141',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø480×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200141.jpg',
        price: '38.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL727',
        article: '2200142',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø480×60 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200142.jpg',
        price: '51.02'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL728',
        article: '2200143',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø490×90 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200143.jpg',
        price: '54.66'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL489',
        article: '2200144',
        wats: '48W',
        color: 'белый',
        diameter: 'Ø380×60 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 3800Lm',
        img: '/img/lamps/lights/2200144.jpg',
        price: '37.41'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL729',
        article: '2200145',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200145.jpg',
        price: '47.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL7212',
        article: '2200158',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×80 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200158.jpg',
        price: '39.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL7214',
        article: '2200159',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø480×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200159.jpg',
        price: '39.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL7215',
        article: '2200160',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø480×70 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200160.jpg',
        price: '39.90'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL12016',
        article: '2300467',
        wats: '120W',
        color: 'белый',
        diameter: 'Ø550×110 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9600Lm',
        img: '/img/lamps/lights/2300467.jpg',
        price: '108.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL7217',
        article: '2300468',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø480×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2300468.jpg',
        price: '55.00'
    },
    {
        material: 'STARLIGHT',
        title: 'SAPRA DL7230',
        article: '2200161',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø500×80 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200161.jpg',
        price: '79.00'
    },
    //-- MODERN 
    {
        material: 'MODERN',
        title: 'SAPRA DL7210',
        article: '2200146',
        wats: '72W',
        color: 'белый',
        diameter: 'Ø450×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200146.jpg',
        price: '64.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL7210',
        article: '2200147',
        wats: '72W',
        color: 'чёрный',
        diameter: 'Ø450×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200147.jpg',
        price: '64.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL9610',
        article: '2200148',
        wats: '96W',
        color: 'белый',
        diameter: 'Ø605×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7680Lm',
        img: '/img/lamps/lights/2200148.jpg',
        price: '105.60'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL9610',
        article: '2200149',
        wats: '96W',
        color: 'чёрный',
        diameter: 'Ø605×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7680Lm',
        img: '/img/lamps/lights/2200149.jpg',
        price: '105.60'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL12010',
        article: '2200150',
        wats: '120W',
        color: 'белый',
        diameter: 'Ø805×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9600Lm',
        img: '/img/lamps/lights/2200150.jpg',
        price: '112.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL12010',
        article: '2200151',
        wats: '120W',
        color: 'чёрный',
        diameter: 'Ø805×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9600Lm',
        img: '/img/lamps/lights/2200151.jpg',
        price: '112.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL4811',
        article: '2200152',
        wats: '48W',
        color: 'белый',
        diameter: '380×380×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 3800Lm',
        img: '/img/lamps/lights/2200152.jpg',
        price: '56.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL4811',
        article: '2200153',
        wats: '48W',
        color: 'чёрный',
        diameter: '380×380×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 3800Lm',
        img: '/img/lamps/lights/2200153.jpg',
        price: '56.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL7211',
        article: '2200154',
        wats: '72W',
        color: 'белый',
        diameter: '500×500×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200154.jpg',
        price: '74.40'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL7211',
        article: '2200155',
        wats: '72W',
        color: 'чёрный',
        diameter: '500×500×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5000Lm',
        img: '/img/lamps/lights/2200155.jpg',
        price: '74.40'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL9611',
        article: '2200157',
        wats: '96W',
        color: 'белый',
        diameter: '600×600×50 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7680Lm',
        img: '/img/lamps/lights/2200157.jpg',
        price: '100.00'
    },
    {
        material: 'MODERN',
        title: 'SAPRA DL9618',
        article: '2300469',
        wats: '96W',
        color: 'чёрный',
        diameter: '500×500×95 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7680Lm',
        img: '/img/lamps/lights/2300469.jpg',
        price: '109.00'
    },
    //--SMART-люстры 
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD101/4',
        article: '2200162',
        wats: '88W',
        color: 'белая',
        diameter: '370×370×80 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 6160Lm',
        img: '/img/lamps/lights/2200162.jpg',
        price: '50.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD101/5',
        article: '2200241',
        wats: '110W',
        color: 'белая',
        diameter: 'Ø590×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7700Lm',
        img: '/img/lamps/lights/2200241.jpg',
        price: '57.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD101/4+4',
        article: '2200242',
        wats: '224W',
        color: 'белая',
        diameter: '880×880×110 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 15680Lm',
        img: '/img/lamps/lights/2200242.jpg',
        price: '103.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD102/4',
        article: '2200163',
        wats: '104W',
        color: 'белая',
        diameter: '550×550×90 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7280Lm',
        img: '/img/lamps/lights/2200163.jpg',
        price: '65.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD102/5',
        article: '2200164',
        wats: '140W',
        color: 'белая',
        diameter: '570×570×130 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9800Lm',
        img: '/img/lamps/lights/2200164.jpg',
        price: '72.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD102/5',
        article: '2300574',
        wats: '140W',
        color: 'чёрная',
        diameter: '545×545×120 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9800Lm',
        img: '/img/lamps/lights/2300574.jpg',
        price: '72.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD102/8',
        article: '2200165',
        wats: '224W',
        color: 'белая',
        diameter: '600×600×120 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 15680Lm',
        img: '/img/lamps/lights/2200165.jpg',
        price: '102.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD102/8',
        article: '2300575',
        wats: '224W',
        color: 'чёрная',
        diameter: '600×600×120 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 15680Lm',
        img: '/img/lamps/lights/2300575.jpg',
        price: '102.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD103/4',
        article: '2200166',
        wats: '84W',
        color: 'белая',
        diameter: '680×520×100 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5880Lm',
        img: '/img/lamps/lights/2200166.jpg',
        price: '34.90'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD103/6',
        article: '2200243',
        wats: '140W',
        color: 'белая',
        diameter: '965×705×135 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9800Lm',
        img: '/img/lamps/lights/2200243.jpg',
        price: '94.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD103/8',
        article: '2200244',
        wats: '216W',
        color: 'белая',
        diameter: '1245×990×135 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 15120Lm',
        img: '/img/lamps/lights/2200244.jpg',
        price: '123.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD104/4',
        article: '2200167',
        wats: '72W',
        color: 'белая',
        diameter: '600×610×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5040Lm',
        img: '/img/lamps/lights/2200167.jpg',
        price: '58.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD104/3+3',
        article: '2200246',
        wats: '162W',
        color: 'белая',
        diameter: 'Ø640×110 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 11340Lm',
        img: '/img/lamps/lights/2200246.jpg',
        price: '88.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD104/6',
        article: '2200168',
        wats: '132W',
        color: 'белая',
        diameter: '840×600×150 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9240Lm',
        img: '/img/lamps/lights/2200168.jpg',
        price: '50.34'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD104/4+4',
        article: '2200247',
        wats: '216W',
        color: 'белая',
        diameter: '670×670×125 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 15120Lm',
        img: '/img/lamps/lights/2200247.jpg',
        price: '109.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD104/8',
        article: '2200245',
        wats: '284W',
        color: 'белая',
        diameter: '1010×815×140 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 19880Lm',
        img: '/img/lamps/lights/2200245.jpg',
        price: '140.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD105/6',
        article: '2200169',
        wats: '120W',
        color: 'белая',
        diameter: 'Ø470×75 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 8400Lm',
        img: '/img/lamps/lights/2200169.jpg',
        price: '61.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD105/8',
        article: '2200170',
        wats: '208W',
        color: 'белая',
        diameter: 'Ø620×115 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 14560Lm',
        img: '/img/lamps/lights/2200170.jpg',
        price: '96.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD106/6',
        article: '2200171',
        wats: '120W',
        color: 'белая',
        diameter: 'Ø750×150 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 8400Lm',
        img: '/img/lamps/lights/2200171.jpg',
        price: '82.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD107/5',
        article: '2200248',
        wats: '80W',
        color: 'белая',
        diameter: 'Ø640×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5600Lm',
        img: '/img/lamps/lights/2200248.jpg',
        price: '65.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD107/9',
        article: '2200249',
        wats: '144W',
        color: 'белая',
        diameter: 'Ø820×120 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 10080Lm',
        img: '/img/lamps/lights/2200249.jpg',
        price: '111.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD107/15',
        article: '2200250',
        wats: '240W',
        color: 'белая',
        diameter: 'Ø975×115 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 16800Lm',
        img: '/img/lamps/lights/2200250.jpg',
        price: '179.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD108/6',
        article: '2200251',
        wats: '132W',
        color: 'белая',
        diameter: 'Ø710×95 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9240Lm',
        img: '/img/lamps/lights/2200251.jpg',
        price: '90.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD109/5',
        article: '2200252',
        wats: '230W',
        color: 'белая',
        diameter: 'Ø570×100 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 16100Lm',
        img: '/img/lamps/lights/2200252.jpg',
        price: '110.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD110/5',
        article: '2200253',
        wats: '140W',
        color: 'белая',
        diameter: 'Ø660×90 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9800Lm',
        img: '/img/lamps/lights/2200253.jpg',
        price: '81.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD111/5',
        article: '2200254',
        wats: '80W',
        color: 'белая',
        diameter: 'Ø740×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5600Lm',
        img: '/img/lamps/lights/2200254.jpg',
        price: '71.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD111/5',
        article: '2300593',
        wats: '80W',
        color: 'чёрная',
        diameter: 'Ø740×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 5600Lm',
        img: '/img/lamps/lights/2300593.jpg',
        price: '71.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD112/5',
        article: '2200255',
        wats: '120W',
        color: 'белая',
        diameter: 'Ø570×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 8400Lm',
        img: '/img/lamps/lights/2200255.jpg',
        price: '64.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD112/5',
        article: '2300594',
        wats: '120W',
        color: 'чёрная',
        diameter: 'Ø570×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 8400Lm',
        img: '/img/lamps/lights/2300594.jpg',
        price: '64.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD113/5',
        article: '2200256',
        wats: '140W',
        color: 'белая',
        diameter: 'Ø640×85 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 9800Lm',
        img: '/img/lamps/lights/2200256.jpg',
        price: '76.00'
    },
    {
        material: 'SMART-люстры',
        title: 'SAPRA LD114/6',
        article: '2300597',
        wats: '104W',
        color: 'чёрная',
        diameter: 'Ø745×125 мм',
        colorLightK: '3000-6500K',
        patron: 'есть',
        lightStream: 'max. 7280Lm',
        img: '/img/lamps/lights/2300597.jpg',
        price: '111.00'
    }
];
